import { create } from 'zustand';
import { Crop } from './cropsService';

interface CropsStore {
	crops: Crop[];
	cropsMonitoring: Crop[];
	cropsByIds: Crop[];

	setCrops: (crops: Crop[]) => void;
	filteredCrops: Crop[];
	setFilteredCrops: (filteredCrops: Crop[]) => void;
	setCropsMonitoring: (crops: Crop[]) => void;
	setCropsByIds: (cropsByIds: Crop[]) => void;
}

export const useCropsStore = create<CropsStore>((set) => ({
	crops: [],
	cropsMonitoring: [],
	cropsByIds: [],
	filteredCrops: [],

	setCrops: (crops) => set({ crops }),
	setCropsMonitoring: (cropsMonitoring) => set({ cropsMonitoring }),
	setCropsByIds: (cropsByIds) => set({ cropsByIds }),
	setFilteredCrops: (filteredCrops) => set({ filteredCrops }),
}));
